<form (ngSubmit)="onSubmit()" #rutForm="ngForm">
  <div class="input-container">
    <label for="rut">Ingresa tu Rut</label>
    <input class="input-rut" type="text" id="rut" name="rut" [(ngModel)]="rut" required placeholder="Rut"/>
    <p *ngIf="error || (!isValidRut(rut) && showErrorInput)" class="error">{{ error ? error : errorInput }}</p> 
  </div>
  <button type="submit" [disabled]="!isValidRut(rut)">
    <div class="spinner-container">
      <mat-spinner *ngIf="isLoading" class="white-spinner"
          [diameter]="24"
      ></mat-spinner>
    </div>
    <ng-container *ngIf="!isLoading">
      Ver mis órdenes de pago
    </ng-container>
    
  </button>
</form>
